import { render } from "./IconOrders.vue?vue&type=template&id=b5a02ad2"
import script from "./IconOrders.vue?vue&type=script&lang=js"
export * from "./IconOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__